export const emailRegexp = /.+@.+\..+/i
export const password = /.+@.+\..+/i

